/*
 * Copyright (c) 2026.  atagon GmbH.  All rights reserved.
 *
 * This file is part of the atagon codebase and may not be copied,
 *  distributed, or modified without explicit written permission from
 * atagon GmbH. https://www.atagon.com
 */

import {useState} from "react";
import useSub from "./useSub.jsx";
import {useDidMount} from "./useDidMount.jsx";
import {Socket} from "../Socket.js";
import useCompareEffect from "./useCompareEffect.jsx";
import {BuildServers} from "../Objects/BuildServers.jsx";
import {Database} from "../APIClient.jsx";

function useBuildServer(buildServerId) {
    const [buildServerInfo, setBuildServerInfo] = useState({})

    async function fetchData() {
        let buildServer = await BuildServers(buildServerId).getInfo()
        setBuildServerInfo(buildServer ?? {})
    }

    useDidMount(() => {
        fetchData()
    })

    useCompareEffect(() => {
        fetchData()
    }, [buildServerId])

    useSub(() => Database.table("BuildServers", "app").onChange((change) => {
        let updated = Socket.applyChange([buildServerInfo], change)[0]
        setBuildServerInfo(updated ?? {})
    }, [{
        column: "indexKey", value: buildServerId
    }]), "liveBuildServerData")

    return buildServerInfo
}

export default useBuildServer;